function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.0893 35.3137C4.92347 35.0911 -2.52764 32.4989 0.847622 31.0267C2.37366 30.3611 7.18641 26.9306 18.0876 27.3044C28.9887 27.6781 46.4564 28.5891 51.5823 28.5891C56.7082 28.5891 61.776 29.9517 63.0714 31.0267C64.3668 32.1018 67.8925 36.3743 60.1235 35.8685C52.8465 35.3947 45.5057 33.8258 42.4251 33.7238C38.7525 33.602 24.1495 35.9198 10.0893 35.3137Z",
  fill: "#E5E9F0",
  fillOpacity: 0.3
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M44.6132 10.1125C44.3971 10.3365 44.3346 10.6916 44.4614 10.9741C44.4996 11.0592 44.5539 11.1383 44.6264 11.1978C44.6892 11.2493 44.7638 11.2848 44.8406 11.312C45.0527 11.387 45.2919 11.3989 45.5024 11.3196C45.7128 11.2403 45.8891 11.0637 45.9414 10.8477",
  fill: "#CCD2DB"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M7.8887 11.4912C8.51165 12.8034 8.47493 14.3024 8.42657 15.7424",
  stroke: "#B8F4E3",
  strokeWidth: 0.0700431
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.96486 14.0605C5.67341 13.8366 5.27843 13.827 4.91248 13.8269C4.6712 13.8268 4.42376 13.8278 4.19796 13.9139C4.03208 13.9772 3.88622 14.0835 3.74254 14.1885L3.11301 14.6485C3.42082 14.6353 3.69248 14.832 3.97339 14.96C4.70024 15.2912 5.61556 15.1423 6.20317 14.5972",
  fill: "#B8F4E3"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M36.5986 21.9786H46.8055V9.17822H36.5986V21.9786Z",
  fill: "#F3F3F3"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M36.4377 30.7147C36.1983 30.7147 36.0016 30.5244 35.992 30.2835L35.7787 24.9219H37.0428L36.8836 30.2789C36.8764 30.5217 36.6789 30.7147 36.4377 30.7147Z",
  fill: "#D4E3FB"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.832868,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.3985 20.5771H35.5215V0.62915H20.3985V20.5771Z",
  fill: "#EBEEF4"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M30.6005 30.7159H30.6004C30.3833 30.6102 30.2884 30.3523 30.3854 30.1313L33.4616 23.6138L34.6081 24.1718L31.196 30.5208C31.083 30.7359 30.8192 30.8223 30.6005 30.7159Z",
  fill: "#D4E3FB"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M42.5956 30.7159C42.8127 30.6102 42.9077 30.3523 42.8106 30.1313L39.7345 23.6138L38.5879 24.1718L42.0001 30.5208C42.1131 30.7359 42.3769 30.8223 42.5956 30.7159Z",
  fill: "#D4E3FB"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M43.9468 20.7315C44.185 19.8681 44.3761 18.9904 44.5805 18.1075C44.7606 17.3301 44.7296 16.6956 44.6929 15.8859C44.6651 15.2705 44.4488 14.7407 43.869 14.4543C43.5712 14.3073 43.221 14.2949 42.8945 14.3563C42.568 14.4177 42.2592 14.5481 41.9535 14.6776C41.1324 15.0254 40.5601 15.3037 39.6432 15.2956C38.8324 15.2883 37.993 15.1512 37.2612 14.79C36.5678 14.4478 35.8567 13.9028 35.0647 14.3392C34.1143 14.8629 34.0052 15.9277 34.1314 16.9109C34.2393 17.7519 34.8733 19.4736 33.6785 19.8514C33.3648 19.9506 33.0254 19.8897 32.7022 19.8279C31.2045 19.5417 29.3648 19.2181 28.3747 20.7183C27.7066 21.7304 27.8865 23.0305 28.6139 23.9591C29.1029 24.5834 29.7669 25.2562 30.5594 25.1987H40.773C42.0716 25.1987 42.7845 23.8704 43.2267 22.837C43.5214 22.1483 43.7501 21.4447 43.9468 20.7315Z",
  fill: "#D4E3FB"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M36.8662 17.7397C36.709 17.65 36.5562 17.5718 36.3957 17.7061C36.2061 17.8649 36.0847 18.2983 35.982 18.5178C35.6737 19.1775 35.4008 19.8527 35.1279 20.5276C34.951 20.9653 34.8376 21.526 34.8124 21.9959C34.8031 22.17 34.6699 22.2709 34.7089 22.4606C34.724 22.534 34.772 22.6055 34.844 22.627C34.9431 22.6566 35.0427 22.5859 35.1454 22.573C35.3745 22.5441 35.7007 22.6372 35.9465 22.642C36.3085 22.6489 36.6702 22.6746 37.0315 22.6982C37.7533 22.7452 38.477 22.7983 39.2006 22.7593C39.6809 22.7334 40.2343 22.617 40.4499 22.1886C40.5487 21.9924 40.5555 21.7639 40.6188 21.5536C40.6832 21.3398 40.8046 21.1484 40.9157 20.9545C41.1136 20.6087 42.2943 18.1305 41.5001 18.0833C41.3309 18.0732 41.1724 18.1595 41.0062 18.1924C40.7252 18.248 40.4398 18.1495 40.1647 18.0701C39.3166 17.8254 38.4185 17.7537 37.5421 17.8607C37.4014 17.8779 37.2565 17.8994 37.12 17.8614C37.033 17.8372 36.949 17.7868 36.8662 17.7397Z",
  fill: "white"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M47.8143 7.35645C48.9167 7.99278 50.4356 8.62911 50.4356 8.62911C50.4356 8.62911 51.5941 10.6817 51.8948 11.3367C52.7181 13.1296 53.4902 14.9449 54.2755 16.7547V30.8549",
  stroke: "#D4E3FB",
  strokeWidth: 0.280172
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.4057 24.0113H4.44513C4.07141 24.0113 3.76849 23.7139 3.76849 23.347V22.8901H16.0823V23.347C16.0823 23.7139 15.7794 24.0113 15.4057 24.0113Z",
  fill: "#D4E3FB"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.59433 24.0112H4.75156L4.90222 29.4303H5.44372L5.59433 24.0112Z",
  fill: "#D4E3FB"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.93918 29.4302L5.00807 32.0463H5.38531L5.4542 29.4302H4.93918Z",
  fill: "#D4E3FB"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.1461 24.0112H14.3033L14.454 29.4303H14.9955L15.1461 24.0112Z",
  fill: "#D4E3FB"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.4903 29.4302L14.5592 32.0463H14.9365L15.0054 29.4302H14.4903Z",
  fill: "#D4E3FB"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.94897 22.875H15.6611V22.3611H9.94897V22.875Z",
  fill: "#EEF1F6"
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.80392,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.277 10.9129C24.3328 10.7511 25.3886 10.5893 26.4444 10.4275C27.4454 10.2742 28.4527 10.1193 29.4103 9.78876C28.0586 7.66635 27.1272 5.85142 25.666 4.09229C25.2414 5.10851 23.2513 10.9168 23.277 10.9129Z",
  fill: "#D4E3FB"
});

var _ref21 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.641276,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M28.4291 8.94283C27.2403 9.31047 26.1871 10.3678 26.0935 11.6568C26.0244 12.6067 26.4873 13.5513 27.1938 14.1556C27.9004 14.7598 28.8231 15.0464 29.7363 15.0828C31.0601 15.1355 32.5059 14.5787 33.1139 13.3517C33.6861 12.1971 33.4428 10.0342 32.3584 9.22485C31.4469 8.54453 29.4248 8.63495 28.4291 8.94283Z",
  fill: "white"
});

var _ref22 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.5107 22.3612H15.38V21.6138H10.5107V22.3612Z",
  fill: "#D4E3FB"
});

var _ref23 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.7918 21.6138H15.6611V20.9131H10.7918V21.6138Z",
  fill: "#EEF1F6"
});

var _ref24 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.2034 22.8901H10.0895V17.1907H6.2034V22.8901Z",
  fill: "#EBEEF4"
});

var _ref25 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.2034 22.8899H10.0895V21.4417H6.2034V22.8899Z",
  fill: "#D4E3FB"
});

var _ref26 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.13692 14.991C8.00325 14.9991 7.90466 15.0713 7.88993 15.3456C7.87565 15.6103 7.98629 15.8791 8.18223 16.0559C8.30976 16.171 8.4671 16.246 8.62208 16.3193C9.00509 16.5007 9.38804 16.6821 9.77105 16.8634C9.94462 16.3755 10.0367 15.8583 10.0423 15.34C10.0443 15.1515 10.0324 14.9538 9.93603 14.7922C9.75855 14.4947 9.28985 14.4353 9.04482 14.6794C8.92291 14.8008 8.84051 14.9587 8.66181 15.0086C8.48958 15.0568 8.29018 14.9817 8.13692 14.991Z",
  fill: "#B8F4E3"
});

var _ref27 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.81902 13.702C6.31578 13.4397 5.74223 13.3253 5.17297 13.313C5.3933 13.6805 5.61362 14.0481 5.83388 14.4156C5.92853 14.5735 6.02492 14.7336 6.16002 14.8596C6.42628 15.108 6.80903 15.1935 7.17506 15.2169C7.53868 15.24 7.90178 15.2206 8.26313 15.2751C7.92006 14.6517 7.47095 14.0419 6.81902 13.702Z",
  fill: "#72EDCA"
});

var _ref28 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.45374 14.6228C5.82728 14.4599 5.15061 14.7247 4.66593 15.1508C4.18125 15.577 3.85234 16.1464 3.53442 16.7061C4.38644 16.5741 5.29679 17.0785 6.09312 16.7503C6.46327 16.5977 6.7466 16.2787 6.91738 15.919C7.08815 15.5592 7.15591 15.1596 7.18643 14.7631",
  fill: "#72EDCA"
});

var _ref29 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.23865 17.7367C6.0277 17.9979 5.73218 18.1902 5.40735 18.2776C5.98448 18.3747 6.6416 18.4526 7.09733 18.0866C7.35942 17.8762 7.50164 17.5558 7.69772 17.2832C8.11554 16.7022 8.74246 16.4106 9.43392 16.3095C8.87789 15.8716 8.24062 15.8355 7.60884 16.0807C6.80617 16.3922 6.72736 17.1316 6.23865 17.7367Z",
  fill: "#72EDCA"
});

var _ref30 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.43027 14.1762C9.79046 14.0176 10.2184 14.0224 10.575 14.1889C10.8 14.2941 10.9923 14.4572 11.1816 14.6183C11.4885 14.8796 11.7954 15.1408 12.1023 15.4021C11.5731 15.5073 11.0176 15.6115 10.5018 15.4525C10.3301 15.3996 10.1661 15.3182 9.98878 15.2902C9.65999 15.2383 9.3298 15.3765 9.04864 15.5555C9.11822 15.5111 8.91285 14.9403 8.91867 14.824C8.93334 14.53 9.17537 14.2885 9.43027 14.1762Z",
  fill: "#72EDCA"
});

var _ref31 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.81345 11.4236C6.59738 11.5982 6.41592 11.8162 6.18202 11.9659C5.88652 12.155 5.51538 12.2212 5.17297 12.146C5.52237 12.4271 5.94393 12.64 6.3916 12.6579C6.83922 12.6758 7.31071 12.4695 7.53063 12.0781C7.67838 11.8152 7.76771 11.6713 8.07267 11.7846C8.10341 11.6011 7.90507 11.3516 7.75508 11.2555C7.44482 11.0567 7.07306 11.2139 6.81345 11.4236Z",
  fill: "#B8F4E3"
});

var _ref32 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.13516 11.2194C9.41251 11.106 9.72417 11.1405 10.0231 11.1239C10.3221 11.1074 10.6545 11.0105 10.7927 10.7434C10.9361 10.9954 10.9031 11.3226 10.7614 11.5756C10.6196 11.8285 10.3837 12.0158 10.1318 12.1578C9.58724 12.4647 8.87589 12.5896 8.26391 12.5615C8.25197 12.3651 8.44077 12.0362 8.52611 11.8569C8.65464 11.5868 8.85229 11.3352 9.13516 11.2194Z",
  fill: "#B8F4E3"
});

var _ref33 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.21245 13.5269C8.82332 13.4509 8.51952 13.2003 8.38393 12.8232C8.3809 12.8149 8.28862 12.5059 8.31479 12.5195C8.68464 12.7119 9.09646 12.4935 9.46862 12.6342C9.76547 12.7464 10.1348 12.983 10.3889 13.1797C10.6342 13.3695 10.8408 13.6221 10.9321 13.9205C10.6618 13.867 10.4177 13.7086 10.1327 13.658C9.82755 13.6038 9.51692 13.5863 9.21245 13.5269Z",
  fill: "#72EDCA"
});

var _ref34 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M49.6694 26.749C49.2364 25.8031 49.0739 24.7356 49.2059 23.7041C49.3729 22.3997 49.9979 21.1399 49.8601 19.8321C49.7804 19.0767 49.4488 18.3702 49.0596 17.7177C48.938 17.5139 48.825 17.2162 49.0147 17.0735C49.5254 17.1123 49.7901 17.6905 49.9215 18.1847C50.5078 20.3893 50.5694 22.7312 50.0996 24.9635C49.9364 25.7391 49.7121 26.5591 49.9818 27.3044",
  fill: "#72EDCA"
});

var _ref35 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M50.4845 26.5736C50.8506 26.8484 51.0355 25.1335 51.0191 24.8935C50.9798 24.3171 50.7926 23.6785 50.9094 23.0996C50.6632 23.6457 50.1948 24.0909 50.1776 24.7322C50.1711 24.9753 50.2666 26.4102 50.4845 26.5736Z",
  fill: "#B8F4E3"
});

var _ref36 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M51.0671 22.7261C51.0011 22.8471 50.9558 22.9721 50.9267 23.0998C50.9874 22.9807 51.0363 22.8571 51.0671 22.7261Z",
  fill: "#B9D4AA"
});

var _ref37 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M52.1761 19.6895C51.8864 20.0876 51.3399 20.2637 51.1023 20.6941C50.7751 21.2867 51.1888 22.0249 51.0672 22.6888C51.0649 22.7014 51.0621 22.7137 51.0595 22.726C51.0794 22.6852 51.1015 22.6448 51.1261 22.605C51.2989 22.3262 51.5732 22.1234 51.7704 21.8609C52.2238 21.2572 52.2096 20.4402 52.1761 19.6895Z",
  fill: "#72EDCA"
});

var _ref38 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M51.0763 26.7228C50.9526 25.9471 51.0357 25.1387 51.3145 24.4051C51.6506 23.5211 52.2618 22.749 52.4852 21.8294C52.6174 21.2851 52.6061 20.7171 52.594 20.1567C52.9705 21.3179 52.9243 22.6139 52.4662 23.7448C52.2281 24.3328 51.8853 24.8719 51.6312 25.453C51.3769 26.034 51.2121 26.6864 51.3576 27.3044",
  fill: "#B8F4E3"
});

var _ref39 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M48.9514 23.2922C48.8717 22.1287 48.1834 21.1105 47.5185 20.1567C47.468 20.5178 47.629 20.8699 47.7595 21.2099C47.9473 21.6991 48.0795 22.2203 48.0495 22.7441C48.0249 23.1748 47.8921 23.5907 47.8111 24.0143C47.6836 24.6809 47.6878 25.3865 47.924 26.0222C48.0842 26.4531 48.5454 27.2522 49.0545 27.3404C49.4114 27.4022 49.279 27.188 49.1796 26.8957C49.0296 26.454 48.8248 26.0266 48.8057 25.5513C48.7756 24.7984 49.0032 24.0502 48.9514 23.2922Z",
  fill: "#B8F4E3"
});

var _ref40 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M48.0131 26.8898C48.0277 26.7292 48.0423 26.5685 48.057 26.4078C48.1207 25.7089 48.1824 24.9888 47.9755 24.3181C47.7686 23.6475 47.224 23.0306 46.5256 22.9597C46.6127 23.3875 46.8637 23.7682 46.9524 24.1956C47.0176 24.51 46.9921 24.8362 47.0339 25.1545C47.1344 25.9176 47.6503 26.613 48.3516 26.9306C48.3164 26.7503 48.281 26.57 48.2458 26.3897",
  fill: "#72EDCA"
});

var _ref41 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M36.5985 8.15051H46.7585V0.62915H36.5985V8.15051Z",
  stroke: "#EEF1F6",
  strokeWidth: 0.0700431
});

var _ref42 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M46.3972 11.6544L43.8811 9.80311L45.0315 8.26975C45.476 7.67728 46.3213 7.55377 46.9197 7.994L47.2692 8.25114C47.8675 8.69138 47.9922 9.52853 47.5476 10.1211L46.3972 11.6544Z",
  fill: "#D4E3FB"
});

var _ref43 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M47.5637 8.66451L46.5501 7.90956L47.4893 6.6421C47.6684 6.40051 48.0089 6.35019 48.2499 6.52967L48.3907 6.63452C48.6317 6.81406 48.682 7.15546 48.5029 7.39705L47.5637 8.66451Z",
  fill: "#D4E3FB"
});

var _ref44 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M44.0658 20.1317C44.0535 20.1439 43.4781 20.3657 43.181 20.3742C42.1411 20.4042 41.0963 20.2523 40.1081 19.9274C39.6375 19.7726 39.1498 19.576 38.6623 19.6651C37.8974 19.8048 37.4253 20.6001 37.2727 21.3615C37.0259 22.5925 36.9271 23.4042 35.5005 23.5497C34.5283 23.6488 33.541 23.6936 32.5783 23.5262C31.6155 23.3587 30.6718 22.965 29.9728 22.2831V24.7816H41.1496L44.0535 20.1439",
  fill: "#D4E3FB"
});

var _ref45 =
/*#__PURE__*/
React.createElement("path", {
  d: "M44.0658 20.1287C44.0535 20.1409 43.4781 20.3613 43.181 20.3698C42.1411 20.3996 41.0963 20.2486 40.1081 19.9257C39.6375 19.7719 39.1498 19.5764 38.6623 19.665C37.8974 19.8038 37.4253 20.5942 37.2727 21.351C37.0259 22.5745 36.9271 23.3813 35.5005 23.5259C34.5283 23.6244 33.541 23.6689 32.5783 23.5025C31.6155 23.336 30.6718 22.9448 29.9728 22.267",
  stroke: "white",
  strokeWidth: 0.0700431
});

var _ref46 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M50.924 30.7614H47.9439C47.1433 29.4544 46.6834 27.945 46.6194 26.4167H51.957C51.9572 27.8273 51.4351 29.4452 50.924 30.7614Z",
  fill: "#D4E3FB"
});

var _ref47 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M53.0581 30.8547H55.4928V30.0605H53.0581V30.8547Z",
  fill: "#D4E3FB"
});

var _ref48 =
/*#__PURE__*/
React.createElement("path", {
  d: "M38.6454 2.46093C38.6217 2.55534 38.5981 2.6543 38.6213 2.74877C38.6446 2.84323 38.7316 2.9297 38.8281 2.91692C38.8946 2.90808 38.9465 2.85708 38.9931 2.80883C39.1234 2.67401 39.2537 2.53912 39.3839 2.4043C39.3952 2.52938 39.4086 2.66066 39.4795 2.76436C39.5505 2.868 39.6993 2.92998 39.8058 2.86344C39.895 2.80776 39.9315 2.68082 40.0319 2.64957C40.2121 2.5935 40.3345 2.89513 40.5228 2.88179C40.6811 2.87053 40.7554 2.6444 40.9135 2.62993C41.0594 2.61664 41.1565 2.79065 41.2998 2.82082C41.5379 2.87098 41.7403 2.51053 41.9666 2.59992C42.0711 2.64119 42.1282 2.76864 42.2378 2.79375C42.3226 2.81317 42.4059 2.76385 42.4889 2.73751C42.6097 2.69911 42.7399 2.70925 42.8662 2.71972C43.5706 2.77826 44.275 2.83676 44.9794 2.89525",
  stroke: "#EEF1F6",
  strokeWidth: 0.0700431,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref49 =
/*#__PURE__*/
React.createElement("path", {
  d: "M38.3838 4.65631C38.4265 4.54705 38.3788 4.42584 38.3777 4.30891C38.3766 4.19197 38.476 4.05125 38.5874 4.09439C38.6388 4.11429 38.6681 4.1661 38.6933 4.21418C38.7852 4.3896 38.8771 4.56498 38.969 4.74046C38.9969 4.60839 39.027 4.4714 39.1109 4.36428C39.1948 4.2571 39.3491 4.18962 39.4749 4.24564C39.637 4.31784 39.6578 4.53049 39.655 4.70433C39.7589 4.50895 39.9023 4.33369 40.0747 4.19175C40.1159 4.29136 40.1599 4.39503 40.2435 4.46487C40.3272 4.53477 40.4631 4.55779 40.5452 4.48614C40.6606 4.38555 40.6661 4.13216 40.8185 4.15837C40.8934 4.1712 40.9278 4.25348 40.9719 4.31401C41.1286 4.5294 41.5458 4.44245 41.5986 4.18342C41.7208 4.3293 41.8763 4.48965 42.0685 4.47129C42.1384 4.4646 42.203 4.43412 42.2694 4.41181C42.4223 4.36027 42.5865 4.35205 42.7482 4.34427C43.0943 4.3276 43.4404 4.31094 43.7865 4.29427C44.1996 4.27437 44.6143 4.25452 45.0262 4.29093",
  stroke: "#EEF1F6",
  strokeWidth: 0.0700431,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref50 =
/*#__PURE__*/
React.createElement("path", {
  d: "M38.4712 5.7031C39.9226 5.69965 41.374 5.69619 42.8255 5.69273",
  stroke: "#EEF1F6",
  strokeWidth: 0.0700431,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref51 =
/*#__PURE__*/
React.createElement("path", {
  d: "M38.6118 6.35197H39.6418",
  stroke: "#EEF1F6",
  strokeWidth: 0.0700431,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgBgThumb1 = function SvgBgThumb1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 60,
    height: 36,
    viewBox: "0 0 65 36",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBgThumb1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bg-thumb-1.243abebe.svg";
export { ForwardRef as ReactComponent };